import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, message, Skeleton, Select as AntSelect } from "antd";
import { DeleteModal } from "components/Dialog";
import { get } from "lodash";
import { Autocomplete } from "@mui/material";
import styled, { keyframes } from "styled-components";
import COLOR from "utils/constants/color";
import {
  Close,
  Delete,
  CheckCircle,
  Preview,
  ChevronLeft,
  ChevronRight,
  Translate,
  AutoAwesome,
  Save,
  Assignment
} from '@mui/icons-material';
import {
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  IconButton,
  InputLabel,
  Modal,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Box,
  Grid,
  Typography,
  CircularProgress,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import BadgeButton from '../BadgeButton';
import SunEditor from "suneditor-react";
import { getAwsAuthToken } from "utils/lib/authHelper";
import sysConf from "config";
import * as Sentry from '@sentry/react';
import { cleanHTMLString } from "utils/methods/textMethod";
import { RetweetOutlined } from '@ant-design/icons';
import Loading from "components/Loading";
import { useLessonPlansByBook } from "store/lesson_plan/selectors";
import { useDispatch } from "react-redux";
import { 
  handleCreateOrUpdateLessonPlan, 
  handleListLessonPlanByBook,
  handleDeleteLessonPlanByBook,
  handleGenerateEnglishLessonPlanForAdmin
} from "store/lesson_plan/thunks";
import {
  blockquote,
  align,
  font,
  fontSize,
  fontColor,
  hiliteColor,
  horizontalRule,
  list,
  table,
  formatBlock,
  lineHeight,
  template,
  paragraphStyle,
  textStyle,
  link,
  image,
} from "suneditor/src/plugins";
import { SPANISH_ITEM_LOWER, SPANISH_ITEM_UPPER } from 'utils/config/reference';


const SPANISH_ITEM_LOWER_PLUGIN = {
  name: "SPANISH_ITEM_LOWER",
  display: "submenu",
  add: function (core, targetElement) {
    let listDiv = this.setSubmenu.call(core);
    var self = this;
    listDiv.querySelectorAll(".se-btn-list-lower").forEach(function (btn) {
      btn.addEventListener("click", self.onClick.bind(core));
    });
    core.initMenuTarget(this.name, targetElement, listDiv);
  },

  setSubmenu: function () {
    const listDiv = this.util.createElement("DIV");
    listDiv.className = "se-submenu se-list-layer";
    listDiv.innerHTML = `<div class="se-list-inner se-list-font-size" style="width:30px;">
      <ul class="se-list-basic">
         ${SPANISH_ITEM_LOWER.map(
           (item) =>
             `<li><button type="button" class="se-btn-list-lower" value="${item}">${item}</button></li>`
         ).join("")}
      </ul></div>`;

    return listDiv;
  },
  onClick: function (e) {
    e.preventDefault();
    e.stopPropagation();
    
    if (!this.context || !this.context.element || !this.context.element.wysiwyg) {
      console.warn('SunEditor context not properly initialized');
      return;
    }
    
    const value = e.target.value;
    const node = this.util.createElement("span");
    this.util.addClass(node, "se-custom-tag");
    node.textContent = value;
    
    try {
      this.insertNode(node);
      const zeroWidthSpace = this.util.createTextNode(this.util.zeroWidthSpace);
      if (node.parentNode) {
        node.parentNode.insertBefore(zeroWidthSpace, node.nextSibling);
      }
      
      const event = new InputEvent("input", {
        bubbles: true,
        cancelable: true,
        inputType: "insertText",
        data: value,
      });
      this.context.element.wysiwyg.dispatchEvent(event);
    } catch (error) {
      console.error('Error inserting Spanish character:', error);
    } finally {
      this.submenuOff();
    }
  },
};

const SPANISH_ITEM_UPPER_PLUGIN = {
  name: "SPANISH_ITEM_UPPER",
  display: "submenu",
  add: function (core, targetElement) {
    let listDiv = this.setSubmenu.call(core);
    var self = this;
    listDiv.querySelectorAll(".se-btn-list-upper").forEach(function (btn) {
      btn.addEventListener("click", self.onClick.bind(core));
    });
    core.initMenuTarget(this.name, targetElement, listDiv);
  },

  setSubmenu: function () {
    const listDiv = this.util.createElement("DIV");
    listDiv.className = "se-submenu se-list-layer";
    listDiv.innerHTML = `<div class="se-list-inner se-list-font-size" style="width:30px;">
      <ul class="se-list-basic">
         ${SPANISH_ITEM_UPPER.map(
           (item) =>
             `<li><button type="button" class="se-btn-list-upper" value="${item}">${item}</button></li>`
         ).join("")}
      </ul></div>`;

    return listDiv;
  },
  onClick: function (e) {
    e.preventDefault();
    e.stopPropagation();
    
    if (!this.context || !this.context.element || !this.context.element.wysiwyg) {
      console.warn('SunEditor context not properly initialized');
      return;
    }
    
    const value = e.target.value;
    const node = this.util.createElement("span");
    this.util.addClass(node, "se-custom-tag");
    node.textContent = value;
    
    try {
      this.insertNode(node);
      const zeroWidthSpace = this.util.createTextNode(this.util.zeroWidthSpace);
      if (node.parentNode) {
        node.parentNode.insertBefore(zeroWidthSpace, node.nextSibling);
      }
      
      const event = new InputEvent("input", {
        bubbles: true,
        cancelable: true,
        inputType: "insertText",
        data: value,
      });
      this.context.element.wysiwyg.dispatchEvent(event);
    } catch (error) {
      console.error('Error inserting Spanish character:', error);
    } finally {
      this.submenuOff();
    }
  },
};


const ModalContent = styled.div`
  left: 50%;
  max-width: 544px;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  min-height: 350px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px; 
  @media only screen and (max-width: 600px) {
    min-width: 90% !important;
  }
`;

const ModalConfigArea = styled.div`
  max-height: 75vh;
  overflow: auto;
  margin-top: 10px;
`;

const LinkArea = styled.div`
  padding: 10px;
  margin: 2px;
  border: 1px dashed;
  margin-top: 24px;
`;

const TitleText = styled.span`
  font-size: 18px;
  color: black;
  font-weight: 600;
`;

const PreviewModalContent = styled.div`
  left: 50%;
  width: 95vw;
  max-width: 1400px;
  max-height: 90vh;
  padding: 20px;
  position: absolute;
  min-height: 600px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 8px;
  overflow-y: auto;
  @media only screen and (max-width: 600px) {
    width: 98vw;
    padding: 10px;
  }
`;

const PageContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #fafafa;
  
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
  }
`;

const ImageContainer = styled.div`
  flex: 1;
  min-width: 300px;
  max-width: 500px;
  
  @media only screen and (max-width: 768px) {
    min-width: 100%;
    max-width: 100%;
  }
`;

const EditorContainer = styled.div`
  flex: 1;
  min-width: 300px;
  
  @media only screen and (max-width: 768px) {
    min-width: 100%;
  }
`;

const PageImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
`;

const pulse = keyframes`
  0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.7); }
  70% { transform: scale(1.05); box-shadow: 0 0 0 10px rgba(76, 175, 80, 0); }
  100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(76, 175, 80, 0); }
`;

const RetryButton = styled.button`
  background-color: #4caf50;
  color: white;
  font-size: 15px;
  font-weight: 600;
  padding: 12px 24px;
  border: none;
  border-radius: 30px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.2s ease;
  animation: ${pulse} 2s infinite;

  &:hover {
    background-color: #43a047;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.97);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    animation: none;
  }
`;

const NoContentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 40px;
  text-align: center;
`;

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: #666;
`;

const ImageViewerContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
`;

const NavigationButton = styled(IconButton)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  z-index: 10;
  width: 50px;
  height: 50px;
  border: 2px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.9);
    border-color: white;
    transform: translateY(-50%) scale(1.1);
  }
  
  &.left {
    left: 15px;
  }
  
  &.right {
    right: 15px;
  }
  
  & .MuiSvgIcon-root {
    font-size: 2rem;
    font-weight: bold;
  }
  
  &:disabled {
    background-color: rgba(0, 0, 0, 0.3);
    color: rgba(255, 255, 255, 0.5);
    border-color: rgba(255, 255, 255, 0.3);
    cursor: not-allowed;
    
    &:hover {
      transform: translateY(-50%);
      background-color: rgba(0, 0, 0, 0.3);
    }
  }
`;

const PageImageContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
`;

const PageImageLarge = styled.img`
  width: 100%;
  height: auto;
  max-height: 600px;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
`;

const PageIndicator = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
  gap: 10px;
`;

const PageDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${props => props.active ? '#1976d2' : '#ccc'};
  cursor: pointer;
  transition: background-color 0.3s ease;
  
  &:hover {
    background-color: ${props => props.active ? '#1976d2' : '#999'};
  }
`;

const StyledSelect = styled(AntSelect)`
  .ant-select-dropdown {
    z-index: 3000 !important;
  }
  
  .ant-select-selector {
    background-color: #1976d2 !important;
    color: white !important;
    border-color: #1976d2 !important;
    border-radius: 4px !important;
    height: 36px !important;
    min-height: 36px !important;
    
    .ant-select-selection-item {
      color: white !important;
      font-weight: 500 !important;
      line-height: 34px !important;
    }

    .ant-select-arrow {
      color: white !important;
    }
  }

  &:hover .ant-select-selector {
    background-color: #1565c0 !important;
    border-color: #1565c0 !important;
  }

  &.ant-select-focused .ant-select-selector {
    box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2) !important;
    border-color: #1976d2 !important;
  }
`;

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 200,
  },
  sunEditorDropdown: {
    '& .se-submenu': {
      top: '100% !important',
      bottom: 'auto !important',
      transform: 'none !important',
    },
    '& .se-list-layer': {
      top: '100% !important',
      bottom: 'auto !important',
    }
  },
}));

function filterOrdersByOrderIds(oneArray, orderIds) {
  const filteredOrders = [];
  for (const orderItem of oneArray) {
    if (orderItem.order && orderItem.order.includes(orderIds)) {
      filteredOrders.push(orderItem);
    }
  }
  return filteredOrders;
}

const LessonPlanModal = ({ 
  planData, 
  booksAllList, 
  pageId, 
  onRemoveAssignmentPlan, 
  updatePlan, 
  bookId, 
  totalPages = 0,
  pages: currentBookPages = [],
  hasPermission = true
}) => {
  const [open, setOpen] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [plan, setPlan] = useState(null);
  const [deleteModal, setDeleteModal] = useState({open:false,type:'default'});
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [combinedContent, setCombinedContent] = useState('');
  const [isGenerating, setIsGenerating] = useState(false);
  const [streamingContent, setStreamingContent] = useState('');
  const [generationError, setGenerationError] = useState(false);
  const [isRetrying, setIsRetrying] = useState(false);
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [isUpdating, setIsUpdating] = useState(false);
  const [bookSelectionMode, setBookSelectionMode] = useState('current');
  const [currentLanguage, setCurrentLanguage] = useState('spanish');
  const [isGeneratingEnglish, setIsGeneratingEnglish] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);
  const dispatch = useDispatch();
  const book_lesson_plan = useLessonPlansByBook();
  const [isDeleting,setIsDeleting] = useState(false);
  const page_plan = useMemo(() => {
    if(Array.isArray(book_lesson_plan) && book_lesson_plan.length > 0){
      return book_lesson_plan.find((pl) => pl.page_id == pageId);
    }
    return null;
  }, [book_lesson_plan, pageId]);
  const classes = useStyles();


  const books_option = useMemo(() => {
    return booksAllList.map((book) => ({
      label: book.description,
      value: book.id
    }));
  }, [booksAllList]);

  const {selectedBook,pages} = useMemo(() => {
    if (bookSelectionMode === 'current') {
      // Use current book pages
      return {
        selectedBook: {
          label: 'Current Book',
          value: bookId
        },
        pages: currentBookPages.map((page) => ({
          ...page,
          NumberMasked: page.NumberMasked || `Page ${page.pageId}`,
          pageId: parseInt(page.pageId)
        }))
      };
    } else {
      // Use other book pages (existing logic)
      const book = booksAllList.find((book) => book.id == get(plan, "resourceId"));
      if(book){
        return {
          selectedBook: {
            label: book.description,
            value: book.id
          },
          pages: book.pages.map((page) => ({
            ...page,
            NumberMasked: page.NumberMasked || `Page ${page.pageId}`,
            pageId:parseInt(page.pageId)
          }))
        };
      }
      return {
        selectedBook: null,
        pages: []
      };
    }
  }, [booksAllList, plan, open, bookSelectionMode, bookId, currentBookPages]);


  useEffect(() => {
    if(planData&&planData.content_type=='ai'){
      setBookSelectionMode('current');
    }else if(planData && planData.to && planData.from && planData.resourceId ) {
      setBookSelectionMode('other');
    }else{
      setBookSelectionMode('current');
    }
  }, [planData]);
  useEffect(() => {
    if (planData) {
      if (!planData?.levelTitle) {
        planData.levelTitle = 'Lesson Plan';
      }
      setPlan(planData);
    } else {
      setPlan({
        page: pageId,
        from: '',
        to: '',
        resourceId: bookSelectionMode === 'current' ? bookId : '',
        levelTitle: 'Lesson Plan'
      });
    }
  }, [planData, open, bookSelectionMode, bookId]);

  useEffect(() => {
    if (page_plan && page_plan.content) {
      setCombinedContent(page_plan.content);
      setCurrentLanguage('spanish');
    } else {
      setCombinedContent('');
    }
  }, [page_plan]);

  useEffect(() => {
    if (page_plan) {
      if (currentLanguage === 'spanish' && page_plan.content) {
        setCombinedContent(page_plan.content);
      } else if (currentLanguage === 'english' && page_plan.content_english) {
        setCombinedContent(page_plan.content_english);
      }
    }
  }, [currentLanguage, page_plan]);

  const onUpdate = () => {
    const pageLengthById = pages?.length;
    const from = parseInt(plan.from);
    const to = parseInt(plan.to);

    if (!(plan.from && plan.resourceId && plan.to)) {
      setError(true);
      setErrorMsg("All fields are required.");
      return;
    }

    if (from > to) {
      setError(true);
      setErrorMsg("From page must be less than or equal to To page.");
      return;
    }

    if (from > pageLengthById || to > pageLengthById) {
      setError(true);
      setErrorMsg(`The selected book has only ${pageLengthById} pages, and you must select within the available range.`);
      return;
    }

    updatePlan({...plan,content_type:bookSelectionMode === 'current'?'ai':'Image'});
    // handleClose();
  };

  const disableBtn = () => {
    return bookSelectionMode === 'current' 
    ? (!Boolean(plan) || !bookId || !plan?.from || !plan?.to)
    :  !Boolean(plan)|| !(plan.from && plan.resourceId && plan.to);
    // (bookSelectionMode !== 'current' && (!Boolean(plan) || !(plan.from && plan.resourceId && plan.to) )) || (bookSelectionMode === 'current' && (!bookId|| !plan?.from || !plan?.to));
  };



  const handleClose = () => {
    setOpen(false);
    setPlan({
      ...plan,
      from: '',
      to: '',
      resourceId: bookSelectionMode === 'current' ? bookId : '',
    });
  };

  const handleBookSelectionModeChange = (event) => {
    const newMode = event.target.value;
    setBookSelectionMode(newMode);
    setError(false);
    setPlan({
      ...plan,
      resourceId: newMode === 'current' ? bookId : '',
      from: '',
      to: '',
    });
  };

  const handleOpen = () => {
    if (!hasPermission) {
      message.warning('You do not have permission to access this feature.');
      return;
    }
    setOpen(true);
  };

  const handlePreviewOpen = async () => {
    if (!plan?.from || !plan?.to || !pages) {
      setError(true);
      setErrorMsg("Please select book and page range before previewing.");
      return;
    }
    if(!(page_plan&&page_plan.id)){
      handleGenerateCombinedContent();
    }
    setCurrentPageIndex(0); // Reset to first page
    setPreviewOpen(true);
  
  
  };



  const handlePreviewClose = () => {
    setPreviewOpen(false);
    setStreamingContent('');
    setIsGenerating(false);
    setGenerationError(false);
  };



  const getPreviewPages = () => {
    if (!pages || !plan?.from || !plan?.to) return [];
    
    const fromPage = parseInt(plan.from);
    const toPage = parseInt(plan.to);
    const startIndex = pages.findIndex(page => page.pageId == fromPage);
    const endIndex = pages.findIndex(page => page.pageId == toPage);
    return pages.slice(startIndex, endIndex + 1);
  };
  async function streamData(inputData, onChunk, onError) {
    try {
      const prodUrl = `${sysConf.apiGateway.AI_BASE_NODE_URL}/ai/generate-lesson-plan-template-stream/lesson-plan-template-stream`;
      const token = await getAwsAuthToken();
      const response = await fetch(prodUrl, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          "x-auth-source": sysConf.isDev ? "test" : "prod",
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(inputData),
      });

      if (!response.ok || !response.body) {
        throw new Error('Stream failed to start');
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder('utf-8');
      let fullTextAccumulator = '';
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const text = decoder.decode(value);
        const lines = text.split('\n').filter(Boolean);

        for (const line of lines) {
          const payload = line.replace('data: ', '').trim();
          if (line.startsWith('data:') && line.replace('data: ', '').trim() === '[DONE]') {
            message.success('Created Successfully');
            return;
          }
          if (payload.startsWith('[ERROR]')) {
            const errorMessage = payload.replace('[ERROR]', '').trim();
            const isTimeoutError = errorMessage.toLowerCase().includes('timeout');
            
            console.error('Stream returned an error:', errorMessage);
            
            if (isTimeoutError) {
              message.error('Connection timed out while generating lesson. Please try again.');
            } else {
              message.error('Failed to generate lesson. Please try again.');
            }
            
            if (onError) {
              onError(errorMessage);
            }
            
            return;
          }
          
          const cleanedLine = line.replace('data: ', '');
          
          if (!cleanedLine.startsWith('[ERROR]')) {
            fullTextAccumulator += cleanedLine;
            onChunk(cleanHTMLString(fullTextAccumulator));
          }
        }
      }
    } catch (error) {
      console.error('Stream error:', error);
      message.error('Failed to create lesson. Please try again.');
      
      if (onError) {
        onError(error.message || 'Network error occurred');
      }
      
      return;
    }
  }

const [streammingOn,setStreammingOn] = useState(false);
  const handleGenerateCombinedContent = async () => {
    if (!plan?.from || !plan?.to || !pages) {
      setError(true);
      setErrorMsg("Please select book and page range before generating content.");
      return;
    }

    setIsGenerating(true);
    setGenerationError(false);
    setStreamingContent('');
    
    try {
      const requestData = {
        chapter: bookSelectionMode === 'current' ? bookId : plan.resourceId,
        bookId,
        from_page: parseInt(plan.from),
        to_page: parseInt(plan.to),
        page_id: parseInt(plan.page), // Using from page as the page_id for the lesson plan
        mode: import.meta.env.VITE_APP_STAGE?.trim() === "prod" ? "prod" : "dev",
        meta_data:{
           content_type: bookSelectionMode === 'current'?'ai':'Image'
        },
      };
      await streamData(
        requestData, 
        async (chunk) => {
          setStreamingContent(chunk);
          setCombinedContent(chunk);
          setIsGenerating(false);
          setStreammingOn(true);
        },
        (errorMessage) => {
          setGenerationError(true);
          setIsGenerating(false);
          setStreammingOn(false);
          setStreamingContent('');
          setCombinedContent('');
        }
      );
      setStreamingContent('');
      try {
       const resp =  await dispatch(handleListLessonPlanByBook(bookId));
       if(resp && resp.error) {
         message.error(resp.error);
       } else if(Array.isArray(resp)){
        if(resp && resp.length > 0){
          const content = resp.find((dt) => dt.page_id == pageId);
          if(content){
            updatePlan({
              ...plan,
              content_type:bookSelectionMode === 'current'?'ai':'Image',
              content_id:content.id
            })
            const content_id = content.id
           handleGenerateEnglishContent({ from_auto: true, content_id });
          }
        }
       }
      } catch (error) {
        console.error('Error fetching lesson plans after generation:', error);
        message.error('Failed to fetch lesson plans after generation. Please try refreshing.');
      }
    } catch (error) {
      console.error('Error generating combined content:', error);
      setGenerationError(true);
    } finally {
      setIsGenerating(false);
      setStreammingOn(false);
    }
  };

  const handleRetryGeneration = async () => {
    setIsRetrying(true);
    setGenerationError(false);

    try {
      await handleGenerateCombinedContent();
    } finally {
      setIsRetrying(false);
    }
  };

  const handleContentChange = (content) => {
    setCombinedContent(content);
  };

  const handleLanguageChange = (value) => {
    if (value === 'regenerate_english') {
      handleGenerateEnglishContent({ from_auto: false });
      return;
    }
    setCurrentLanguage(value);
  };

  const handleGenerateEnglishContent = async ({ from_auto = false, content_id = null }) => {
    if (!page_plan?.content && !content_id) {
      message.error('No Spanish content available to translate');
      return;
    }

    setIsGeneratingEnglish(true);
    try {
      const result = await dispatch(handleGenerateEnglishLessonPlanForAdmin(
        content_id || page_plan.id, 
        bookId
      ));
      
      if (result && result.content_english) {
        const listResp = await dispatch(handleListLessonPlanByBook(bookId));
        if(listResp && listResp.error) {
          message.warning(`English content generated, but failed to refresh lesson plans: ${listResp.error}`);
        }
        if(!from_auto){
          setCombinedContent(result.content_english);
          setCurrentLanguage('english');
        }
        message.success('English content generated successfully! Switched to English view.');
      } else {
        message.error('Failed to generate English content');
      }
    } catch (error) {
      console.error('Error generating English content:', error);
      message.error('Error generating English content');
    } finally {
      setIsGeneratingEnglish(false);
    }
  };

  const handleUpdateContent = async () => {
    if (!combinedContent.trim()) {
      message.error('Please add some content before updating.');
      return;
    }

    setIsUpdating(true);
    
    try {
      const lessonPlanData = {
        chapter: bookId,
        page_id: pageId,
        created_by: 'admin',
        parent_id: null,
        user_type: 'admin',
        content_type: bookSelectionMode === 'current'?'ai':'Image'
      };

      if (currentLanguage === 'english') {
        lessonPlanData.content_english = combinedContent;
        lessonPlanData.content = page_plan?.content;
      } else {
        lessonPlanData.content = combinedContent;
        lessonPlanData.content_english = page_plan?.content_english;
      }

      const result = await dispatch(handleCreateOrUpdateLessonPlan(lessonPlanData));
      
      if (result && !result.error) {
        message.success('Lesson plan updated successfully!');
        const listResp = await dispatch(handleListLessonPlanByBook(bookId));
        if(listResp && listResp.error) {
          message.warning(`Lesson plan updated, but failed to refresh list: ${listResp.error}`);
        }
      } else {
        message.error(result?.error || 'Failed to update lesson plan');
      }
    } catch (error) {
      console.error('Error updating lesson plan:', error);
      message.error('Failed to update lesson plan');
    } finally {
      setIsUpdating(false);
    }
  };

  const onDeleteLessonPlan = async () => {
    if (!page_plan?.id) {
      message.error('No lesson plan found to delete.');
      return;
    }

    setIsDeleting(true);
    
    try {
      const result = await dispatch(handleDeleteLessonPlanByBook(page_plan.id));
      
      if (result && !result.error) {
        message.success('Lesson plan deleted successfully!');
        setCombinedContent(''); // Clear the editor content
        // Optionally close the modal or refresh data
        // handlePreviewClose();
      } else {
        message.error(result?.error || 'Failed to delete lesson plan');
      }
    } catch (error) {
      console.error('Error deleting lesson plan:', error);
      message.error('Failed to delete lesson plan');
    } finally {
      setDeleteModal({open:false,type:'default'});
      setIsDeleting(false);
      setIsUpdating(false);
      handlePreviewClose()
    }
  };
  const onDeleteLessionPlanPlan = async () => {
    if(planData.content_type === "ai" || (planData.content_type === "Image"&& deleteModal.type === 'content')||(typeof planData.content_type === "undefined")){
      onRemoveAssignmentPlan(planData.page)
    }
  }

  const handlePreviousPage = () => {
    const previewPages = getPreviewPages();
    if (currentPageIndex > 0) {
      setCurrentPageIndex(currentPageIndex - 1);
    }
  };

  const handleNextPage = () => {
    const previewPages = getPreviewPages();
    if (currentPageIndex < previewPages.length - 1) {
      setCurrentPageIndex(currentPageIndex + 1);
    }
  };

  const getCurrentPage = () => {
    const previewPages = getPreviewPages();
    return previewPages[currentPageIndex] || null;
  };

  // useEffect(() => {
  //   setImageLoading(true);
  // }, [currentPageIndex]);

 const disableAIButton = () => {
  const is_wrong_page = plan?.from && plan?.to && plan?.from > plan?.to;
  return bookSelectionMode === 'current' 
  ? (!Boolean(plan) || !bookId || !plan?.from || !plan?.to || is_wrong_page)
  :  !Boolean(plan)|| !(plan.from && plan.resourceId && plan.to || is_wrong_page);
  // (bookSelectionMode !== 'current' && (!Boolean(plan) || !(plan.from && plan.resourceId && plan.to) )) || (bookSelectionMode === 'current' && (!bookId|| !plan?.from || !plan?.to));
 };
const pageOptions = useMemo(() => {
  if (!plan?.from || !pages) return [];
  const fromPageId = parseInt(plan.from);
  const startIndex = pages.findIndex(page => page.pageId == fromPageId);
  return pages.slice(startIndex, startIndex + 10);
}, [pages, plan?.from]);

  return (
    <>
      <BadgeButton
        onClick={handleOpen}
        startIcon={<Assignment />}
        showBadge={planData}
        backgroundColor="#6366f1"
      >
        Lesson Plan
      </BadgeButton>
      
      <Modal
        open={open}
        onClose={handleClose}
        style={{ height: "100%", width: "100%" }}
      >
      <ModalContent>
        <DeleteModal 
          deleteToggle={deleteModal.open} 
          onDelete={() => {
            if(page_plan&&page_plan.id){
              onDeleteLessonPlan();
            }
            onDeleteLessionPlanPlan();
            setDeleteModal({open:false,type:'default'});
            handleClose();
          }}
          setDeleteToggle={val=>setDeleteModal({open:val,type:'default'})}
          message={ deleteModal.type === 'ai' ? `Are you sure you want to remove the AI-generated lesson plan?` : `Are you sure you want to remove this lesson plan?`} 
        />
        
        <Row style={{ justifyContent: "space-between" }}>
          <TitleText>Lesson Plan</TitleText>
          <IconButton
            onClick={handleClose}
            style={{ padding: 0 }}
          >
            <Close color="secondary" />
          </IconButton>
        </Row>
        
        <ModalConfigArea>
          <LinkArea>
            <Row
              gutter={[24, 24]}
              style={{ justifyContent: "space-between", display: "flex", alignItems: "center", paddingLeft: "10px" }}
            >
              {totalPages && (
                <FormHelperText style={{ width: "400px" }}>
                  Total Pages: {totalPages}
                </FormHelperText>
              )}
              {planData&&planData.resourceId && (
                <IconButton
                  onClick={() => setDeleteModal({open:true,type:'content'})}
                  style={{ padding: 0, marginRight: 10 }}
                >
                  <Delete color="secondary" />
                </IconButton>
              )}
            </Row>
            
            <Row gutter={[24, 24]} style={{ marginTop: 10 }}>
              <Col span={24}>
                <TextField
                  id="levelTitle"
                  name="levelTitle"
                  label="Level Title*"
                  InputLabelProps={{ shrink: true, required: true }}
                  type="text"
                  variant="outlined"
                  inputProps={{ maxLength: 30 }}
                  onChange={(e) => {
                    setPlan({
                      ...plan,
                      levelTitle: e.target.value,
                    });
                  }}
                  value={get(plan, "levelTitle")}
                />
              </Col>
            </Row>
            
            <Row gutter={[24, 24]} style={{ marginTop: 20 }}>
              <Col span={24}>
                <FormControl component="fieldset">
                  <FormLabel component="legend" style={{ marginBottom: 10, fontWeight: 600 }}>
                    Select Content Source
                  </FormLabel>
                  <RadioGroup
                    value={bookSelectionMode}
                    
                    onChange={handleBookSelectionModeChange}
                  >
                    <div style={{ marginBottom: 8 }}>
                      <Radio value="current" disabled={planData&&planData.resourceId} />
                      <label style={{ marginLeft: 8 }}>Generate AI lesson plan with current book</label>
                    </div>
                    <div>
                      <Radio value="other" disabled={planData&&planData.resourceId} />
                      <label style={{ marginLeft: 8 }}>Use images from other book</label>
                    </div>
                  </RadioGroup>
                </FormControl>
              </Col>
            </Row>
            
            {bookSelectionMode === 'other' && (
              <Row
                gutter={[24, 24]}
                style={{ marginTop: 20, marginRight: 0, marginLeft: 0 }}
                className="floatingLabelBG"
              >
                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel id="bookId">Book</InputLabel>
                  <Autocomplete
                    id="bookId"
                    options={books_option}
                    getOptionLabel={(option) => {
                      if (!option || typeof option !== 'object') return '';
                      return `${option.label || ""} (${option.value || ""})`;
                    }}
                    value={selectedBook}
                    onChange={(event, newValue) => {
                      setError(false);
                      setPlan({
                        ...plan,
                        resourceId: newValue ? newValue.value : "",
                        from: '',
                        to: '',
                      });
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Book" variant="outlined"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            padding: '0px'
                          },
                          '& .MuiOutlinedInput-input': {
                            padding: '14px 14px'
                          }
                        }}
                      />
                    )}
                  />
                </FormControl>
              </Row>
            )}
            
            <Row gutter={[24, 24]} style={{ marginTop: 20 }}>
              <Col span={24}>
                <Typography variant="body2" color="textSecondary" style={{ marginBottom: 8 }}>
                  {bookSelectionMode === 'current' ? 'Select pages from current book for AI lesson generation (Maximum 20 pages can be selected)' : 'Select pages from other book for lesson plan'}
                </Typography>
                <FormControl variant="outlined" className={classes.formControl} fullWidth>
                  <InputLabel id="fromPageLabel">From Page</InputLabel>
                  <Autocomplete
                    id="fromPage"
                    options={pages || []}
                    getOptionLabel={(option) => {
                      if (!option || typeof option !== 'object') return '';
                      const pageId = option.pageId != null ? option.pageId : '';
                      return String(option.NumberMasked || `Page ${pageId}` || '');
                    }}
                    value={pages?.find(page => page.pageId == parseInt(plan?.from)) || null}
                    onChange={(event, newValue) => {
                      setError(false);
                      setPlan({
                        ...plan,
                        from: newValue ? newValue.pageId : '',
                        to: '', // Clear 'to' page when 'from' page changes
                      });
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="From Page" variant="outlined"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            padding: '0px'
                          },
                          '& .MuiOutlinedInput-input': {
                            padding: '14px 14px'
                          }
                        }}
                      />
                    )}
                  />
                </FormControl>
              </Col>
            </Row>
            
            <Row gutter={[24, 24]} style={{ marginTop: 20 }}>
              <Col span={24}>
                <FormControl variant="outlined" className={classes.formControl} fullWidth>
                  <InputLabel id="toPageLabel">To Page</InputLabel>
                  <Autocomplete
                    id="toPage"
                    options={pageOptions}
                    getOptionLabel={(option) => String(option.NumberMasked || `Page ${option.pageId}`)}
                    value={pageOptions?.find(page => page.pageId == parseInt(plan?.to)) || null}
                    onChange={(event, newValue) => {
                      setError(false);
                      setPlan({
                        ...plan,
                        to: newValue ? newValue.pageId : '',
                      });
                    }}
                    disabled={!plan?.from}
                    renderInput={(params) => (
                      <TextField 
                        {...params} 
                        label="To Page" 
                        variant="outlined"
                        placeholder={!plan?.from ? "Please select 'From Page' first" : bookSelectionMode === 'current' ? "Select ending page (max 25 pages)" : "Select ending page"}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            padding: '0px'
                          },
                          '& .MuiOutlinedInput-input': {
                            padding: '14px 14px'
                          }
                        }}
                      />
                    )}
                  />
                </FormControl>
              </Col>
            </Row>
          </LinkArea>
          
          {error && (
            <FormHelperText error style={{ width: "400px" }}>
              {errorMsg}
            </FormHelperText>
          )}
          
                  <Row
          gutter={[24, 24]}
          style={{ marginTop: 20, marginRight: 0, marginLeft: 0 }}
        >
          <Col span={12}>
            <Button
              fullWidth
              disabled={disableAIButton()}
              onClick={handlePreviewOpen}
              color="secondary"
              variant="outlined"
              startIcon={<Preview />}
            >
            {page_plan&&page_plan.id?<CheckCircle/>:null}  AI Lesson
            </Button>
          </Col>
          <Col span={12}>
          {bookSelectionMode != 'current' && <Button
              fullWidth
              disabled={disableBtn()}
              onClick={onUpdate}
              color="primary"
              variant="contained"
            >
              Update
            </Button>}
          </Col>
        </Row>
        </ModalConfigArea>
      </ModalContent>
    </Modal>

    {/* Preview Modal */}
    <Modal
      open={previewOpen}
      onClose={handlePreviewClose}
      style={{ height: "100%", width: "100%" }}
    >
      <PreviewModalContent>
        <Row style={{ justifyContent: "space-between", marginBottom: 20 }}>
          <TitleText>Preview and AI Lesson</TitleText>
          <Box style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleGenerateCombinedContent}
              disabled={isGenerating || disableAIButton() || isUpdating || streammingOn || isGeneratingEnglish}
              size="small"
              loading={isGenerating}
              startIcon={<AutoAwesome />}
              sx={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                height: '36px',
                minHeight: '36px',
                '&:hover': {
                  background: 'linear-gradient(135deg, #5568d3 0%, #63438a 100%)',
                },
                '&:disabled': {
                  background: 'rgba(0, 0, 0, 0.12)',
                }
              }}
            >
              {page_plan?.id ? 'Re-generate AI Lesson' : 'Generate AI Lesson'}
            </Button>
            {page_plan?.content_english ? (
              <StyledSelect
                value={currentLanguage}
                onChange={handleLanguageChange}
                style={{ minWidth: 120, height: 36 }}
                size="small"
                placement="bottomLeft"
                getPopupContainer={() => document.body}
                dropdownStyle={{ zIndex: 3000 }}
                disabled={isGenerating || streammingOn || isUpdating || isDeleting || isGeneratingEnglish}
                loading={isGeneratingEnglish}
                options={[
                  { value: 'spanish', label: '🇪🇸 Spanish' },
                  { value: 'english', label: '🇺🇸 English' },
                  { 
                    value: 'regenerate_english', 
                    label: '🔄 Regenerate English',
                    disabled: isGenerating || streammingOn || isUpdating || isDeleting || isGeneratingEnglish
                  }
                ]}
              />
            ) : (
              page_plan?.content && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleGenerateEnglishContent}
                  disabled={isGeneratingEnglish || isUpdating || isGenerating || streammingOn || isDeleting}
                  size="small"
                  startIcon={isGeneratingEnglish ? <CircularProgress size={16} /> : <Translate />}
                  sx={{
                    background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                    height: '36px',
                    minHeight: '36px',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #3a8ee6 0%, #00d4e6 100%)',
                    },
                    '&:disabled': {
                      background: 'rgba(0, 0, 0, 0.12)',
                    }
                  }}
                >
                  {isGeneratingEnglish ? 'Translating...' : 'Translate to English'}
                </Button>
              )
            )}
            <Button
              variant="contained"
              color="success"
              onClick={handleUpdateContent}
              disabled={!combinedContent.trim() || isUpdating || isGenerating || streammingOn || isDeleting || isGeneratingEnglish}
              size="small"
              startIcon={<Save />}
              sx={{
                background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                height: '36px',
                minHeight: '36px',
                '&:hover': {
                  background: 'linear-gradient(135deg, #0f8078 0%, #2ed368 100%)',
                },
                '&:disabled': {
                  background: 'rgba(0, 0, 0, 0.12)',
                }
              }}
            >
              {isUpdating ? 'Updating...' : 'Update'}
            </Button>
            {page_plan && (
              <Button
                variant="contained"
                color="error"
                onClick={()=>setDeleteModal({open:true,type:'ai'})}
                disabled={isUpdating || isGenerating || streammingOn || isGeneratingEnglish}
                size="small"
                startIcon={<Delete sx={{ color: 'white !important' }} />}
                sx={{
                  background: 'linear-gradient(135deg, #f857a6 0%, #ff5858 100%)',
                  color: 'white',
                  height: '36px',
                  minHeight: '36px',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #e04395 0%, #e84343 100%)',
                  },
                  '&:disabled': {
                    background: 'rgba(0, 0, 0, 0.12)',
                  }
                }}
              >
                {isDeleting ? 'Deleting...' : 'Delete'}
              </Button>
            )}
            <IconButton
              onClick={handlePreviewClose}
              style={{ padding: 0 }}
            >
              <Close color="secondary" />
            </IconButton>
          </Box>
        </Row>
        
        <Box style={{ display: 'flex', height: '70vh', maxHeight: '70vh', gap: '20px', padding: '0 20px', overflow: 'hidden' }}>
          {/* Left Side - Image Viewer */}
          <Box style={{ flex: '0 0 50%', display: 'flex', flexDirection: 'column', padding: '0 10px', overflow: 'hidden' }}>
            <ImageViewerContainer>
              <Typography variant="h6" style={{ marginBottom: 20, textAlign: 'center' }}>
                Page Viewer ({currentPageIndex + 1} of {getPreviewPages().length})
              </Typography>
              
              {getCurrentPage() ? (
                <PageImageContainer>
                  <NavigationButton
                    className="left"
                    onClick={handlePreviousPage}
                    disabled={currentPageIndex === 0}
                    size="large"
                  >
                    <ChevronLeft />
                  </NavigationButton>
                  
                  {imageLoading && (
                    <Box style={{ 
                      position: 'absolute', 
                      top: '50%', 
                      left: '50%', 
                      transform: 'translate(-50%, -50%)',
                      zIndex: 1
                    }}>
                      <CircularProgress size={50} />
                    </Box>
                  )}
                  
                  <PageImageLarge
                    src={getCurrentPage().resource}
                    alt={`Page ${getCurrentPage().NumberMasked || getCurrentPage().pageId}`}
                    onLoad={() => setImageLoading(false)}
                    onLoadStart={() => setImageLoading(true)}
                    onError={(e) => {
                      setImageLoading(false);
                      e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZGRkIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkltYWdlIG5vdCBmb3VuZDwvdGV4dD48L3N2Zz4=';
                    }}
                    style={{ opacity: imageLoading ? 0.3 : 1, transition: 'opacity 0.3s ease' }}
                  />
                  
                  <NavigationButton
                    className="right"
                    onClick={handleNextPage}
                    disabled={currentPageIndex === getPreviewPages().length - 1}
                    size="large"
                  >
                    <ChevronRight />
                  </NavigationButton>
                </PageImageContainer>
              ) : (
                <Box style={{ textAlign: 'center', padding: '40px' }}>
                  <Typography variant="h6" color="textSecondary">
                    No pages to display
                  </Typography>
                </Box>
              )}
              
              {getPreviewPages().length > 1 && (
                <PageIndicator>
                  {getPreviewPages().map((page, index) => (
                    <PageDot
                      key={page.pageId}
                      active={index === currentPageIndex}
                      onClick={() => setCurrentPageIndex(index)}
                    />
                  ))}
                </PageIndicator>
              )}
            </ImageViewerContainer>
          </Box>
          
          {/* Right Side - Editor */}
          <Box style={{ flex: '0 0 50%', display: 'flex', flexDirection: 'column', padding: '0 10px', overflow: 'hidden' }}>
            <Typography variant="h6" style={{ marginBottom: 20 }}>
              AI Generated Lesson Content
            </Typography>
            
            {generationError ? (
              <NoContentContainer>
                <div style={{ color: '#ff4d4f', fontWeight: 'bold', marginBottom: '20px' }}>
                  Uh-oh! Looks like the internet took a quick break. Give it another shot!
                </div>
                <RetryButton 
                  disabled={isRetrying} 
                  onClick={handleRetryGeneration}
                >
                  {isRetrying ? (
                    <Loading size={16} white />
                  ) : (
                    <span>
                      <RetweetOutlined style={{ marginRight: 5 }} /> Try again
                    </span>
                  )}
                </RetryButton>
              </NoContentContainer>
            ) : (
              <Box style={{ flex: 1, minHeight: 0 , paddingBottom: '20px' }}>
                {isGenerating ? (
                  <Box style={{ padding: '20px', height: 'calc(70vh - 200px)' }}>
                    <Skeleton 
                      active 
                      paragraph={{ rows: 8, width: ['100%', '95%', '90%', '85%', '80%', '75%', '70%', '65%'] }}
                      title={{ width: '60%' }}
                    />
                    <Typography variant="body2" color="textSecondary" style={{ textAlign: 'center', marginTop: '20px' }}>
                      Generating AI lesson content...
                    </Typography>
                  </Box>
                ) : (
                  <Box style={{ padding: '0 20px 20px 20px' }}>
                    <Box className={classes.sunEditorDropdown} style={{ borderBottom:"0.5px solid #80808094" , maxHeight: '75vh', overflowY: 'auto' , overflowX: 'hidden' }}>
                    <SunEditor
                      setContents={streamingContent || combinedContent || ''}
                      onChange={handleContentChange}
                      setOptions={{
                        height: 'calc(60vh - 100px)',
                        buttonList: [
                          ['undo', 'redo'],
                          ['font', 'fontSize', 'formatBlock'],
                          ['paragraphStyle', 'blockquote'],
                          ['bold', 'underline', 'italic'],
                          ['fontColor', 'hiliteColor', 'textStyle'],
                          ['removeFormat'],
                          ['outdent', 'indent'],
                          ['align', 'horizontalRule', 'list', 'lineHeight'],
                          ['table'],
                          [
                            {
                              name: "SPANISH_ITEM_LOWER",
                              dataCommand: "SPANISH_ITEM_LOWER",
                              buttonClass: "",
                              title: `${SPANISH_ITEM_LOWER[0]}`,
                              dataDisplay: "submenu",
                              innerHTML: `<span>${SPANISH_ITEM_LOWER[0]}</span>`,
                            },

                            //...
                          ],
                          [
                            {
                              name: "SPANISH_ITEM_UPPER",
                              dataCommand: "SPANISH_ITEM_UPPER",
                              buttonClass: "",
                              title: `${SPANISH_ITEM_UPPER[0]}`,
                              dataDisplay: "submenu",
                              innerHTML: `<span>${SPANISH_ITEM_UPPER[0]}</span>`,
                            },
                          ],
                        ],
                        plugins: [
                          blockquote,
                          align,
                          font,
                          fontSize,
                          fontColor,
                          hiliteColor,
                          horizontalRule,
                          list,
                          table,
                          formatBlock,
                          lineHeight,
                          template,
                          paragraphStyle,
                          textStyle,
                          link,
                          image,
                          SPANISH_ITEM_LOWER_PLUGIN,
                          SPANISH_ITEM_UPPER_PLUGIN,
                        ],
                        placeholder: 'AI will generate combined lesson content for all selected pages...'
                      }}
                    />
                    </Box>
                  </Box>
                )}
              </Box>
            )}
          </Box>
        </Box>
        
        {getPreviewPages().length === 0 && (
          <NoContentContainer>
            <div style={{ color: '#ff4d4f', fontWeight: 'bold', marginBottom: '20px' }}>
              No pages to preview. Please select a valid page range.
            </div>
          </NoContentContainer>
        )}
      </PreviewModalContent>
    </Modal>
    </>
  );
};

export default LessonPlanModal;
